// Admin-related API calls
import api from './api';

const adminApi = {
  // Get admin settings
  getSettings: () => {
    return api.get('/admin/settings');
  },
  
  // Update admin settings
  updateSettings: (settings) => {
    return api.post('/admin/settings', settings);
  }
};

export default adminApi;